import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=0f52e0f6&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=0f52e0f6&prod&lang=scss&scoped=true"
import style1 from "./ChatBox.vue?vue&type=style&index=1&id=0f52e0f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52e0f6",
  null
  
)

export default component.exports